import YoutubeContainer from "../component/common/YoutubeContainer"
import React from "react"
import { useTranslation } from "react-i18next"

const sectionMessage = {
  title: "The Science of Catching Up in Life",
  YoutubeLink: "IOWelVx5CUw",
}

const Resources = () => {
  const { t } = useTranslation()

  return (
    <>
      <section className="mx-auto max-w-7xl p-8 bg-blue-100">
        <h1 className="text-2xl md:text-4xl font-semibold mb-4">
          {t("resources.title")}
        </h1>
        <p className="text-lg md:text-xl text-gray-600">
          {t("resources.subtitle")}
        </p>
      </section>
      <section className="mx-auto max-w-7xl p-8 space-y-4">
        <h2 className="text-xl md:text-2xl font-semibold">
          {sectionMessage.title}
        </h2>
        <div className="py-5">
          <YoutubeContainer youtubeLink={sectionMessage.YoutubeLink} />
        </div>
      </section>
    </>
  )
}

export default Resources
